import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { E3TimeSeriesEditCard } from "./edit_card";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";
import { DataUploadActionsCard } from "@/components/DataUploadActionsCard";

const client = "e3";
const table_name = "e3_data_upload";

export const E3DataUploadEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50">
      <div className="mx-auto max-w-[1400px] p-6">
        <div className="grid grid-cols-1 gap-6 xl:grid-cols-3 xl:gap-10">
          <div className="xl:col-span-2 xl:pt-2">
            <div className="mx-auto max-w-[960px]">
              <E3TimeSeriesEditCard
                id={Number(id)}
                client={client}
                table_name={table_name}
              />
            </div>
            <div className="mx-auto mt-10 w-full max-w-[960px]">
              <TechnicalInfoCard
                id={Number(id)}
                table_name={table_name}
                client={client}
                include_tsf_id={false}
                align="start"
              />
            </div>
          </div>

          <aside className="flex flex-col items-stretch gap-12 xl:col-span-1 xl:items-end xl:pt-2 xl:self-start">
            <DataUploadActionsCard
              id={Number(id)}
              client={client}
              table_name={table_name}
            />
          </aside>
        </div>

        <div className="mt-10 flex flex-col gap-10">
          <AuditCard
            id={Number(id)}
            client={client}
            audit_table_name={table_name}
          />
        </div>
      </div>
    </div>
  );
};
